import { type Writable } from '../../utils/typescriptUtils';

export default (rects: DOMRect[]): DOMRect => {
  if (!rects.length) {
    throw new Error('No rects given');
  }

  const result = rects.slice(1).reduce((draftPartialResult: DOMRect, rect: DOMRect) => {
    const partialResult: Writable<Partial<DOMRect>> = {};

    (['bottom', 'right'] as const).forEach((key: 'bottom' | 'right') => {
      partialResult[key] = Math.max(draftPartialResult[key], rect[key]);
    });

    (['left', 'top', 'x', 'y'] as const).forEach((key: 'left' | 'top' | 'x' | 'y') => {
      partialResult[key] = Math.min(draftPartialResult[key], rect[key]);
    });

    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- partialResult is Writable<Partial<DOMRect>> used as a reduce accumulator; the final merged value is a valid DOMRect shape
    return partialResult as DOMRect;
  }, rects[0]);

  result.height = Math.abs(result.bottom - result.top);
  result.width = Math.abs(result.right - result.left);

  return new DOMRect(result.x, result.y, result.width, result.height);
};
